// Application entry point and global context provider mounting.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import '@/app/index.css';
import App from '@/app/App';
import { AuthProvider } from '@/features/auth/AuthContext';
import { TierProvider } from '@/features/tier';
import ErrorFallback from '@/app/ErrorFallback';
import CookieConsentBanner from '@/features/consent/CookieConsentBanner';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [],
  environment: import.meta.env.MODE,
});

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <AuthProvider>
        <TierProvider>
          <App />
          <CookieConsentBanner />
        </TierProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

// Hide loading screen after app is rendered
const loadingScreen = document.getElementById('loading-screen');
if (loadingScreen) {
  loadingScreen.style.display = 'none';
}
